module.exports = __webpack_public_path__ + "static/media/galeria_elo_06.09906ed7.jpg";